@if ($loading()) {
  <div class="loading-state">
    <i class="fa-regular fa-spinner-third fa-spin"></i>
  </div>
} @else {
  @if ($showInternalSearch() && $showSearch()) {
    @if ($mode() === 'popup') {
      <div class="search-section">
        <div class="search-wrapper">
          <i class="fa-regular fa-magnifying-glass search-icon"></i>
          <input #searchInput type="text" class="search-input" placeholder="Search conversations..." [ngModel]="$searchQuery()" (ngModelChange)="$searchQuery.set($event)" />
        </div>
      </div>
    } @else {
      <div class="search-section">
        <div class="search-wrapper">
          <i class="fa-regular fa-magnifying-glass search-icon"></i>
          <input #searchInput type="text" class="search-input" placeholder="Search by name" [ngModel]="$searchQuery()" (ngModelChange)="$searchQuery.set($event)" />
        </div>
      </div>
    }
  }

  <div class="thread-items">
    @if ($isEmpty()) {
      <div class="empty-state">
        <img class="empty-illustration" src="/images/ai/agent-oops.svg" alt="" />
        <span class="empty-text">No conversations</span>
      </div>
    } @else if ($hasNoResults()) {
      <div class="empty-state">
        <img class="empty-illustration" src="/images/ai/agent-oops.svg" alt="" />
        <span class="empty-text">No results</span>
      </div>
    } @else {
      @for (group of $groupedThreads(); track group.label; let isLast = $last) {
        <div class="thread-group">
          <div class="group-label">{{ group.label }}</div>
          @for (thread of group.threads; track thread.id) {
            <div class="thread-item" [class.selected]="thread.id === $activeThreadId()" (click)="onThreadClick(thread)">
              <span class="unread-dot" [class.has-unread]="$indicatorMap().get(thread.id)?.unread"></span>
              <span class="title" [class.shimmer]="$indicatorMap().get(thread.id)?.shimmer" [wbTitleReveal]="thread.title || 'Untitled chat'">{{ thread.title || 'Untitled chat' }}</span>
              <span class="timestamp">{{ thread.updatedAt | timeago }}</span>
              <wb-button-icon class="delete-btn" [iconLeft]="'fa-regular fa-trash-can'" [tooltip]="'Delete conversation'" [displayStyle]="ButtonDisplayStyle.Tertiary" [accent]="ButtonAccent.Danger" (onClick)="onDeleteClick($event, thread)"></wb-button-icon>
            </div>
          }
        </div>
        @if (!isLast) {
          <w-divider orientation="horizontal"></w-divider>
        }
      }
    }
  </div>
}
